(function(angular) {
    'use strict';

    angular.module('aprima-legacy-common').factory('SecurityRepository', [
        'PermissionService',
        SecurityRepository
    ]);

    function SecurityRepository(
        PermissionService
    ) {
        var service = {
            getPermissions: getPermissions
        };

        return service;

        function getPermissions(permissionName) {
            return PermissionService.isAllowedJs(permissionName).then(function (isAllowed) {
                return {
                    IsAllowed: isAllowed,
                };
            });
        }
    }

})(window.angular);
